<div class="annual-plan-dialog-form-phase">
    <form [formGroup]="importPlanForm">
        <h1 mat-dialog-title>
            {{ data.dialogTitle | translate}}
        </h1>
        <div mat-dialog-content>
            <fieldset [disabled]="isSubmitting">
                <div class="line">
                    <mat-form-field color="primary">
                        <mat-select placeholder="{{ 'AnnualPlan' | translate }}" formControlName="plan">
                            <mat-option *ngFor="let annualPlan of annualPlans" [value]="annualPlan">
                                {{ annualPlan.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="line line-margin">
                    <mat-form-field [hintLabel]="'date_format_hint' | translate">
                        <mat-label class="required">{{ 'AnnualPlanStartedAt' | translate }}</mat-label>
                        <input matInput #startedAt formControlName="startedAt" [matDatepicker]="pickerStartedAt" autocomplete="off">
                        <mat-datepicker-toggle matSuffix [for]="pickerStartedAt"></mat-datepicker-toggle>
                        <mat-datepicker #pickerStartedAt startView="year" [startAt]="startDate"></mat-datepicker>
                        <mat-error *ngIf="f['startedAt'].errors && f['startedAt'].errors?.['required']">{{ 'Field_required' | translate }}</mat-error>
                    </mat-form-field>
                </div>
            </fieldset>
        </div>
        <mat-dialog-actions>

            <button mat-button mat-dialog-close tabindex="-1">
                {{ 'Cancel' | translate}}
            </button>

            <button mat-raised-button (click)="submitForm()" color="accent">
                {{ 'Import' | translate}}
            </button>

        </mat-dialog-actions>
    </form>
</div>
